import { ILicenseAccepted } from '../../../actions/userAccount/user/fetchLicense'
import { IUserAccountStore } from '../index'

export default function(
  state: IUserAccountStore,
  action: ILicenseAccepted,
): IUserAccountStore {
  return {
    ...state,
    license: {
      isLoading: false,
      items: action.license,
    },
  }
}
